<template>
  <div class="lms-empty" :class="{ 'is-card': card }">
    <div class="lms-empty__icon-wrap">
      <v-icon v-if="icon" :icon="icon" size="40" color="primary" />
    </div>
    <p v-if="title" class="lms-empty__title">{{ title }}</p>
    <p class="lms-empty__message">{{ message }}</p>
    <div v-if="$slots.default" class="lms-empty__actions">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: '' },
  message: { type: String, default: 'No data available' },
  icon: { type: String, default: 'mdi-chart-box-outline' },
  card: { type: Boolean, default: true }
})
</script>

<style scoped>
.lms-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  padding: 28px 20px;
  color: var(--lms-text-secondary);
  font-weight: 600;
}

.lms-empty.is-card {
  background: var(--lms-surface);
  border: 1px dashed var(--lms-border);
  border-radius: 12px;
  max-width: 420px;
  margin: 0 auto;
}

.lms-empty__icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: var(--lms-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.lms-empty__title {
  margin: 0;
  font-family: Outfit, 'Source Sans 3', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--lms-primary-dark);
}

.lms-empty__message {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.45;
  max-width: 28em;
}

.lms-empty__actions {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
</style>
